import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BrowserDetectionServices,
  DownloadFileServices,
  HandleErrorService,
  LoadingService,
  ParameterCodecService,
  AuthService,
  UserPinSessionService,
  UserPinAuthService,
  UserPinService,
  PersonalService,
  PermissionsService,
  ModulesService,
  CertificatesPrivateService,
  CertificatesPendingService,
  UtilsService,
  FeedMessageService,
  UserService,
  SessionService,
  SessionKeepAliveService,
  LanguageService,
  CustomValidators,
  SigntrustService,
  DocumentConfigurationService,
  SigntrustUtilsService,
} from './index.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    BrowserDetectionServices,
    DownloadFileServices,
    HandleErrorService,
    LoadingService,
    ParameterCodecService,
    AuthService,
    UserPinSessionService,
    UserPinAuthService,
    UserPinService,
    PermissionsService,
    ModulesService,
    CertificatesPrivateService,
    CertificatesPendingService,
    UtilsService,
    FeedMessageService,
    LanguageService,
    PersonalService,
    UserService,
    SessionService,
    SessionKeepAliveService,
    CustomValidators,
    SigntrustService,
    DocumentConfigurationService,
    SigntrustUtilsService,
  ],
  declarations: []
})
export class ServiceModule { }
